(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hero-banner]').forEach(function (root) {
      var desc = root.querySelector('[data-hero-description]');
      var btn = root.querySelector('[data-hero-toggle]');
      if (!desc || !btn) return;

      var lineClamp = parseInt(root.getAttribute('data-line-clamp'), 10) || 3;
      var expanded = false;
      var collapsedHeight = 0;

      function computeCollapsedHeight() {
        var lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
        if (isNaN(lineHeight)) lineHeight = 24;
        return Math.round(lineHeight * lineClamp);
      }

      function setup() {
        collapsedHeight = computeCollapsedHeight();
        var fullHeight = desc.scrollHeight;

        if (fullHeight <= collapsedHeight + 4) {
          btn.style.display = 'none';
          desc.style.maxHeight = 'none';
          return;
        }

        btn.style.display = '';
        if (!expanded) {
          desc.style.maxHeight = collapsedHeight + 'px';
        }
      }

      btn.addEventListener('click', function () {
        expanded = !expanded;

        if (expanded) {
          desc.style.maxHeight = desc.scrollHeight + 'px';
          btn.textContent = btn.getAttribute('data-read-less');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          // Ensure we animate FROM a concrete pixel value, not "none".
          desc.style.maxHeight = desc.scrollHeight + 'px';
          void desc.offsetHeight; // force reflow
          desc.style.maxHeight = collapsedHeight + 'px';
          btn.textContent = btn.getAttribute('data-read-more');
          btn.setAttribute('aria-expanded', 'false');
        }
      });

      window.addEventListener('resize', function () {
        if (expanded) {
          desc.style.maxHeight = desc.scrollHeight + 'px';
        } else {
          collapsedHeight = computeCollapsedHeight();
          desc.style.maxHeight = collapsedHeight + 'px';
        }
      });

      setup();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
